<template>
    <form-row title="Have you received your Mortgage Commitment?">
        <div class="flex flex-col sm:flex-row flex-1 sm:items-center">
            <input-radio-multi
                name="has_received_mortgage_commitment"
                :value="mortgage.has_received_mortgage_commitment"
                :options="[
                    { label: 'Yes', value: 1, },
                    { label: 'No', value: 0, },
                    { label: 'N/A', value: -1, },
                ]"
                :read_only="read_only"
            />
        </div>
    </form-row>
</template>

<script>
export default {
    props: {
        mortgage: {},
        read_only: { default: false },
    },
}
</script>
